/**
 * Записи психолога
 * Табы, пагинация, попап деталей, поиск с фильтрами
 */
var PsyAppointments = {
	moduleId: 9,
	currentPages: { past: 1, canceled: 1, search: 1 },
	searchInitialized: false,
	searchFilters: {},

	/**
	 * Инициализация
	 */
	init: function() {
		var container = document.querySelector('[data-psy-appointments-module-id]');
		if (!container) return;
	},

	/**
	 * Переключение вкладок
	 */
	switchTab: function(tab) {
		// Обновляем активную вкладку
		document.querySelectorAll('[data-appointments-tab]').forEach(function(el) {
			if (el.dataset.appointmentsTab === tab) {
				el.classList.add('active');
			} else {
				el.classList.remove('active');
			}
		});

		// Показываем/скрываем контент
		['upcoming', 'past', 'canceled', 'search'].forEach(function(t) {
			var content = document.getElementById('psy-appointments-tab-' + t);
			if (content) {
				if (t === tab) {
					content.classList.remove('appointments-tab-content--hidden');
				} else {
					content.classList.add('appointments-tab-content--hidden');
				}
			}
		});

		// Инициализация flatpickr при первом открытии вкладки поиска
		if (tab === 'search' && !this.searchInitialized) {
			this.initSearchFilters();
			this.searchInitialized = true;
		}
	},

	/**
	 * Инициализация flatpickr на полях дат поиска
	 */
	initSearchFilters: function() {
		if (typeof flatpickr === 'undefined') return;

		flatpickr('#search-date-from', {
			dateFormat: 'Y-m-d',
			altInput: true,
			altFormat: 'd.m.Y',
			allowInput: false
		});

		flatpickr('#search-date-to', {
			dateFormat: 'Y-m-d',
			altInput: true,
			altFormat: 'd.m.Y',
			allowInput: false
		});
	},

	/**
	 * Поиск записей по фильтрам
	 */
	search: function() {
		var self = this;
		var resultsContainer = document.getElementById('search-results');
		var emptyMessage = document.getElementById('search-empty');

		if (!resultsContainer) return false;

		// Собираем фильтры
		this.searchFilters = {
			client_id: document.getElementById('search-client').value,
			date_from: document.getElementById('search-date-from').value,
			date_to: document.getElementById('search-date-to').value,
			format: document.getElementById('search-format').value,
			status: document.getElementById('search-status').value
		};

		// Сброс пагинации
		this.currentPages.search = 1;

		// Показать загрузку
		resultsContainer.innerHTML = '<div class="psy-profile__loading">Поиск...</div>';
		if (emptyMessage) emptyMessage.style.display = 'none';

		var formData = new FormData();
		formData.append('action', 'search_appointments');
		Object.keys(this.searchFilters).forEach(function(key) {
			formData.append(key, self.searchFilters[key]);
		});

		fetch('/ajax.php?mid=' + this.moduleId, {
			method: 'POST',
			body: formData
		})
		.then(function(r) { return r.json(); })
		.then(function(res) {
			if (res.success) {
				if (res.html && res.html.trim()) {
					resultsContainer.innerHTML =
						'<div class="appointments-history">' + res.html + '</div>';

					if (res.has_more) {
						resultsContainer.insertAdjacentHTML('beforeend',
							'<div class="appointments-list__load-more">' +
							'<button class="btn btn--secondary" type="button" onclick="PsyAppointments.loadMore(\'search\')">Показать ещё</button>' +
							'</div>');
					}
				} else {
					resultsContainer.innerHTML = '';
					if (emptyMessage) emptyMessage.style.display = 'block';
				}
			}
		})
		.catch(function() {
			resultsContainer.innerHTML = '<div class="psy-profile__error">Ошибка поиска</div>';
		});

		return false;
	},

	/**
	 * Сброс фильтров и результатов поиска
	 */
	resetSearch: function() {
		document.getElementById('search-client').value = '';
		document.getElementById('search-format').value = '';
		document.getElementById('search-status').value = '';

		// Сбрасываем flatpickr
		var dateFrom = document.getElementById('search-date-from');
		var dateTo = document.getElementById('search-date-to');
		if (dateFrom && dateFrom._flatpickr) dateFrom._flatpickr.clear();
		if (dateTo && dateTo._flatpickr) dateTo._flatpickr.clear();

		// Очищаем результаты
		var resultsContainer = document.getElementById('search-results');
		if (resultsContainer) resultsContainer.innerHTML = '';

		var emptyMessage = document.getElementById('search-empty');
		if (emptyMessage) emptyMessage.style.display = 'none';

		this.searchFilters = {};
		this.currentPages.search = 1;
	},

	/**
	 * Открыть попап деталей записи (AJAX, серверный HTML)
	 * Вызывается и со страницы записей, и из расписания
	 */
	openPopup: function(appointmentId) {
		var popup = document.getElementById('popup-psy-appointment');
		if (!popup) return;

		var content = popup.querySelector('.popup__content');
		content.innerHTML = '<div class="psy-profile__loading">Загрузка...</div>';
		popup.classList.add('active');
		document.body.style.overflow = 'hidden';

		fetch('/ajax.php?mid=' + this.moduleId + '&action=get_appointment_popup&id=' + appointmentId)
			.then(function(r) { return r.text(); })
			.then(function(html) {
				content.innerHTML = html;
			})
			.catch(function() {
				content.innerHTML = '<div class="psy-profile__error">Ошибка загрузки</div>';
			});
	},

	/**
	 * Закрыть попап
	 */
	closePopup: function() {
		var popup = document.getElementById('popup-psy-appointment');
		if (popup) {
			popup.classList.remove('active');
			document.body.style.overflow = '';
		}
	},

	/**
	 * Показать сообщение об отмене (через телеграм)
	 */
	showCancelMessage: function() {
		var msg = document.getElementById('psy-cancel-message');
		if (msg) {
			msg.style.display = 'block';
		}
	},

	/**
	 * Показать форму "Записать на следующий раз" в попапе
	 */
	openDuplicateForm: function(appointmentId) {
		var popup = document.getElementById('popup-psy-appointment');
		if (!popup) return;

		var content = popup.querySelector('.popup__content');
		content.innerHTML = '<div class="psy-profile__loading">Загрузка...</div>';
		popup.classList.add('active');
		document.body.style.overflow = 'hidden';

		fetch('/ajax.php?mid=' + this.moduleId + '&action=get_duplicate_form&id=' + appointmentId)
			.then(function(r) { return r.text(); })
			.then(function(html) {
				content.innerHTML = html;
				// Инициализируем flatpickr для даты
				var dateInput = content.querySelector('#duplicate-date');
				if (dateInput && window.flatpickr) {
					flatpickr(dateInput, {
						dateFormat: 'Y-m-d',
						altInput: true,
						altFormat: 'd.m.Y',
						locale: 'ru',
						minDate: 'today'
					});
				}
			});
	},

	/**
	 * Записать на следующий раз (отправка формы дубликата)
	 */
	openDuplicate: function(appointmentId) {
		this.openDuplicateForm(appointmentId);
	},

	submitDuplicate: function(form) {
		var btn = form.querySelector('[type="submit"]');
		var errorEl = document.getElementById('duplicate-error');
		if (btn) { btn.disabled = true; btn.textContent = 'Создание записи...'; }
		if (errorEl) errorEl.textContent = '';

		var formData = new FormData(form);
		formData.append('mid', this.moduleId);
		formData.append('action', 'duplicate');

		var self = this;
		fetch('/ajax.php', { method: 'POST', body: formData })
			.then(function(r) { return r.text(); })
			.then(function(text) {
				var res;
				try { res = JSON.parse(text); } catch(e) {
					if (errorEl) errorEl.innerHTML = 'Ошибка сервера';
					if (btn) { btn.disabled = false; btn.textContent = 'Создать запись'; }
					return;
				}
				if (res.success) {
					self.closePopup();
					window.location.reload();
				} else {
					if (errorEl) {
						errorEl.innerHTML = (res.error || 'Ошибка') + '<br><a href="/psy-cabinet/schedule/" style="color: #8E5049;">Посмотреть расписание</a>';
					}
					if (btn) { btn.disabled = false; btn.textContent = 'Создать запись'; }
				}
			})
			.catch(function() {
				if (errorEl) errorEl.innerHTML = 'Ошибка сети';
				if (btn) { btn.disabled = false; btn.textContent = 'Создать запись'; }
			});
		return false;
	},

	/**
	 * Загрузить ещё записи (пагинация)
	 */
	loadMore: function(tab) {
		var self = this;
		var nextPage = this.currentPages[tab] + 1;
		var btn = document.querySelector('#psy-appointments-tab-' + tab + ' .appointments-list__load-more button');

		if (btn) {
			btn.disabled = true;
			btn.textContent = 'Загрузка...';
		}

		var formData = new FormData();
		if (tab === 'search') {
			formData.append('action', 'load_search_page');
			formData.append('page', nextPage);
			// Передаём текущие фильтры
			Object.keys(this.searchFilters).forEach(function(key) {
				formData.append(key, self.searchFilters[key]);
			});
		} else {
			formData.append('action', 'load_' + tab + '_page');
			formData.append('page', nextPage);
		}

		fetch('/ajax.php?mid=' + this.moduleId, {
			method: 'POST',
			body: formData
		})
		.then(function(r) { return r.json(); })
		.then(function(res) {
			if (res.success) {
				self.currentPages[tab] = nextPage;

				// Вставляем HTML в конец списка
				var list = document.querySelector('#psy-appointments-tab-' + tab + ' .appointments-history');
				if (list) {
					list.insertAdjacentHTML('beforeend', res.html);
				}

				// Скрываем или обновляем кнопку
				if (!res.has_more) {
					var loadMoreContainer = document.querySelector('#psy-appointments-tab-' + tab + ' .appointments-list__load-more');
					if (loadMoreContainer) loadMoreContainer.remove();
				} else if (btn) {
					btn.disabled = false;
					btn.textContent = 'Показать ещё';
				}
			}
		})
		.catch(function() {
			if (btn) {
				btn.disabled = false;
				btn.textContent = 'Показать ещё';
			}
		});
	}
};

$(document).ready(function() {
	PsyAppointments.init();
});

window.PsyAppointments = PsyAppointments;
